import {useCallback, useMemo, useState} from 'react';
import {useGetUserProfileQuery} from '../pages/Profile/Profile.api';
import {getActiveTariff} from '../utils/tariffFormat';
import {
    dismissSubscriptionExpiryBanner,
    shouldShowSubscriptionExpiryBanner,
} from '../utils/subscriptionExpiryBanner';
import {useAppSelector} from './app';

export function useSubscriptionExpiryBanner() {
    const {token} = useAppSelector(state => state.app);
    const {data: profile} = useGetUserProfileQuery({token}, {skip: !token});
    const [dismissedInSession, setDismissedInSession] = useState(false);

    const active = getActiveTariff(profile?.tariff);
    const endsAt = active?.ends_at ?? null;
    const userId = profile?.id ?? null;

    const visible = useMemo(() => {
        if (dismissedInSession) {
            return false;
        }

        return shouldShowSubscriptionExpiryBanner(active, userId);
    }, [active, userId, dismissedInSession]);

    const dismiss = useCallback(() => {
        if (!userId || !endsAt) {
            return;
        }

        dismissSubscriptionExpiryBanner(userId, endsAt);
        setDismissedInSession(true);
    }, [userId, endsAt]);

    return {
        visible,
        endsAt,
        active,
        dismiss,
    };
}
